import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline} from "gsap";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {ImmortalFruits} from "../../ImmortalFruits"


export class ImmortalFruitsNearWin implements GameRoundPresentation {
    private readonly _reelId: number;
    private  _duration: number;


    /**
     * @constructs
     * @param reelId
     * @param duration
     */
    constructor(reelId: number, duration: number) {
        this._reelId = reelId;
        this._duration = Math.max(ImmortalFruits.timelineReelsController.getReelConfig(this._reelId).nearWinDuration, duration);
        //Because of how the reels work now, this duration needs to be longer than the configured value  REEL_NEAR_WIN_STOP_DELAY in game config. Set the config to 0 if you want to control it in with this duration.
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: SpinParsedGameData): Timeline | null {

        if ( !data.wasFeatureBuy && (data.nearWinReels[this._reelId] || data.nearWinBigWinReels[this._reelId]) ) {
            return ImmortalFruits.timelineReelsController.startNearWin(this._reelId, this._duration);
        }
        return null;
    }

}